import React from 'react';

import { useSportsbookState } from '@atlas/core';
import { EmptyStateView } from '@atlas/ui';

const SimplifiedSportsbookLoader = ({ children }) => {
  const { error } = useSportsbookState();

  if (error) {
    return (
      <div className="empty-state-wrapper">
        <EmptyStateView
          className="absolute"
          description="sportsbook_empty_description"
          title="sportsbook_no_events"
        />
      </div>
    );
  }

  return children;
};

export default SimplifiedSportsbookLoader;
